module.exports = __webpack_public_path__ + "static/media/DerechoImgEng.cde2c768.png";